import { render, staticRenderFns } from "./simple_viewer.vue?vue&type=template&id=7a8ba104"
import script from "./simple_viewer.vue?vue&type=script&lang=js"
export * from "./simple_viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports